import { OosContribution } from './oosContribution.model';

export class Contribution {
    constructor() {
        this.OosContrbution = new Array<OosContribution>();
    }
    ContributionTypeId: string;
    PaidById: string;
    BasedOnId: string;
    SelectedPlanId: string;
    SeletedPlanName: string;
    PercentageEmployee: string;
    PercentageDep: string;
    AmountEmployee: string;
    AmountDep: string;
    IsEmployeePayAll:boolean;
    IsRollToAccess: boolean;
    OosContrbution: OosContribution[];
}

export class EmployeePremiumRate {
    MemberId: number=0;
    EmployeeOnly: number=0;
    EmployeeAndSpouse: number;
    EmployeeAndChildrenFrom0To21: number=0;
    EmployeeAndChildrenFrom21To26: number=0;
    EmployeeAndFamily: number=0;
    EmployeeOnlyPay: number=0;
    EmployeeAndFamilyPay: number=0;
    EmployeeAndSpousePay: number=0;
    EmployeeAndChildrenFrom0To21Pay: number=0;
    EmployeeAndChildrenFrom21To26Pay: number=0;
  }